var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboardSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0L0 128v112.57a847.12 847.12 0 00431.8 738.32L512 1024l80.2-45.11A847.12 847.12 0 001024 240.57V128zm251.36 395.77L507.47 651.66a73.11 73.11 0 01-103.43 0L282.83 530.45A73.14 73.14 0 11386.26 427l69.49 69.48 204.18-204.14a73.14 73.14 0 11103.43 103.43z"
  })));
}
export default SvgKeyboardSecurity;